import * as t from "react";
import { jsx as u } from "react/jsx-runtime";
var o = t.createContext(
  void 0
), i = (e) => {
  const r = t.useContext(o);
  if (!r)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return r;
}, s = ({
  client: e,
  children: r
}) => (t.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ u(o.Provider, { value: e, children: r }));
export {
  o as QueryClientContext,
  s as QueryClientProvider,
  i as useQueryClient
};
//# sourceMappingURL=contact-channels52.js.map
